module.exports = __webpack_public_path__ + "static/img/ent-67.2af9da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-67.jpg
// module id = vDAO
// module chunks = 52